exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--dark:var(--theme_color_dark);--accent:var(--theme_color_accent);--ocean:var(--theme_color_light);--button-border:var(--theme_border_color)}input[type=radio]{width:15px;outline:0;border:0;cursor:pointer;margin:0 auto;display:block}input[type=radio]:after{background-color:#fff}input[type=radio]:after,input[type=radio]:checked:after{width:15px;height:15px;border-radius:15px;top:-1px;left:-1px;margin:0;padding:7px;position:relative;content:\"\";display:inline-block;visibility:visible;border:2px solid #bfbfbf}input[type=radio]:checked:after{background-color:var(--theme_color_accent);background-color:var(--accent,#dd2160)}", ""]);

// exports
